import {Component, Input} from '@angular/core';

const MOCKUP_IMAGE = 'assets/images/empty-basket.webp';

@Component({
  selector: 'app-fruit-icon',
  standalone: true,
  template: `
    <img [src]="imgSrc" [alt]="product" class="fruit-img" [class.fallback]="isFallback" (error)="onImageError()"/>
  `,
  styles: [`
    :host {
      display: inline-flex;
      line-height: 0;
      font-size: 1.5rem;
    }

    .fruit-img {
      width: 1.5em;
      height: 1.5em;
      object-fit: cover;
      border-radius: 4px;
    }

    .fruit-img.fallback {
      object-fit: contain;
      filter: grayscale(1) opacity(0.45);
    }
  `],
})
export class FruitIconComponent {
  @Input() product = '';

  private _imageUrl: string | null = null;
  private imageFailed = false;

  /** User-uploaded product image. When empty or it fails to load, the mockup is shown. */
  @Input()
  set imageUrl(value: string | null) {
    this._imageUrl = value;
    this.imageFailed = false;
  }

  get imageUrl(): string | null {
    return this._imageUrl;
  }

  protected get imgSrc(): string {
    if (this.imageUrl && !this.imageFailed) {
      return this.imageUrl;
    }
    return MOCKUP_IMAGE;
  }

  protected get isFallback(): boolean {
    return !this.imageUrl || this.imageFailed;
  }

  protected onImageError(): void {
    this.imageFailed = true;
  }
}
